import Avatar from './Avatar';
export { AvatarSize } from './constants';
export * from './Avatar';
export default Avatar;
